import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs";

// Connects to data-controller="position-reorder"
export default class extends Controller {
  connect() {
    const options = {
      handle: ".drag_handle",
      animation: 150,
      delay: 300,
      delayOnTouchOnly: true,
      onEnd: this.#changePosition.bind(this)
    }
    Sortable.create(this.element, options)
  }

  #changePosition(event) {
    const form = event.item.querySelector('.position_change_form') || event.item.querySelector('form')
    const beforeElement = form.querySelector('.before_id')
    const afterElement = form.querySelector('.after_id')

    const newIndex = event.newIndex
    const siblings = Array.from(event.to.children).filter(el => el.matches('[data-id]'))
    const beforeEl = siblings[newIndex - 1] || null
    const afterEl = siblings[newIndex + 1] || null
    beforeElement.value = beforeEl?.dataset.id || ''
    afterElement.value = afterEl?.dataset.id || ''
    form.requestSubmit();
  }
}
